(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lalumi-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-lalumi-add');
    if (!id) return;
    var prev = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        return fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); });
      })
      .then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: sections });
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.textContent = prev;
        btn.disabled = false;
      });
  });
})();
